import SectionHub from '@/components/docs/SectionHub';

export default function Docs01MarketDataStocksHub() {
  return <SectionHub sectionPath="01-market-data/stocks" />;
}
